/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingLinkDetailModel } from '../../models/onboarding-link-detail-model';

export interface AnonymousBranchOnboardingLinkIdGet$Params {
  id: string;
}

export function anonymousBranchOnboardingLinkIdGet(http: HttpClient, rootUrl: string, params: AnonymousBranchOnboardingLinkIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OnboardingLinkDetailModel>> {
  const rb = new RequestBuilder(rootUrl, anonymousBranchOnboardingLinkIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OnboardingLinkDetailModel>;
    })
  );
}

anonymousBranchOnboardingLinkIdGet.PATH = '/Anonymous/BranchOnboardingLink/{id}';
